<template>
  <div class="query-history-container">
    <HomeHeader />
    <div class="w1200" id="main_content">
      <div class="query-history-content">
  

        <!-- 查询历史列表 -->
        <div class="history-list-container">
          <el-table :data="formattedHistoryList" style="width: 100%;" border v-loading="loading" :span-method="arraySpanMethod" stripe>
            <!-- 查询详情列（需要合并） -->
      
            <el-table-column prop="query_time" label="查询时间" width="120">
              <template #default="scope">
                <span>{{ formatDateTime(scope.row.query_time) }}</span>
              </template>
            </el-table-column>
                 <!-- 公司报价列（不需要合并） -->
            <el-table-column prop="company_name" label="公司名称" width="100" />
            <el-table-column prop="is_success" label="查询状态" width="80">
              <template #default="scope">
                <el-tag :type="scope.row.is_success ? 'success' : 'danger'">
                  {{ scope.row.is_success ? '成功' : '失败' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="total_price" label="总报价" width="120">
              <template #default="scope">
                <span v-if="scope.row.is_success && scope.row.total_price">
                  ¥{{ scope.row.total_price }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column prop="destination" label="目的地" width="100">
              <template #default="scope">
                <span>{{ scope.row.query_params.destination }}</span>
              </template>
            </el-table-column>
                        <el-table-column prop="size_spec" label="尺寸规格">
              <template #default="scope">
                <span>{{ scope.row.query_params.size_spec || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="actual_weight" label="实际重量(kg)" width="80">
              <template #default="scope">
                <span>{{ scope.row.query_params.actual_weight }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="volume_spec" label="总体积(m³)" width="80">
              <template #default="scope">
                <span>{{ scope.row.query_params.volume_spec || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="pieces" label="件数" width="80">
              <template #default="scope">
                <span>{{ scope.row.query_params.pieces || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payment_type" label="支付类型" width="80">
              <template #default="scope">
                <span>{{ scope.row.query_params.payment_type || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="item_name" label="货物名称" width="80">
              <template #default="scope">
                <span>{{ scope.row.query_params.item_name || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="declared_value" label="保价额度" width="80">
              <template #default="scope">
                <span>{{ scope.row.query_params.declared_value || '--' }}</span>
              </template>
            </el-table-column>

            
       
          </el-table>
        </div>


      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { getWlApi, postWlApi } from '@utils/api_v1.js'
import HomeHeader from '@components/HomeHeader.vue'

// 查询历史列表
const historyList = ref([])
const formattedHistoryList = ref([])
const total = ref(0)
const loading = ref(false)

// 分页参数
const currentPage = ref(1)
const pageSize = ref(10)

// 格式化日期时间
const formatDateTime = (datetime) => {
  if (!datetime) return ''
  const date = new Date(datetime)
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

// 格式化历史数据为表格行数据
const formatHistoryData = () => {
  const formatted = []
  
  // 按查询ID分组，为每个公司的结果创建一行
  historyList.value.forEach(history => {
    const { query_id, query_time, query_params, results } = history
    
    results.forEach(result => {
      formatted.push({
        query_id,
        query_time,
        query_params,
        ...result // 包含company_id, is_success, total_price等公司相关字段
      })
    })
  })
  
  formattedHistoryList.value = formatted
}

// 表格合并单元格方法
const arraySpanMethod = ({ row, column, rowIndex, columnIndex }) => {
  // 只对查询详情列（前10列）进行合并
  if (![1,2,3,].includes(columnIndex)) {
    const currentQueryId = formattedHistoryList.value[rowIndex].query_id
    let rowspan = 1
    
    // 计算当前查询ID的行数
    for (let i = rowIndex + 1; i < formattedHistoryList.value.length; i++) {
      if (formattedHistoryList.value[i].query_id === currentQueryId) {
        rowspan++
      } else {
        break
      }
    }
    
    // 如果不是当前查询ID的第一行，则不显示
    if (rowIndex > 0) {
      const prevQueryId = formattedHistoryList.value[rowIndex - 1].query_id
      if (prevQueryId === currentQueryId) {
        return { rowspan: 0, colspan: 0 }
      }
    }
    
    return { rowspan, colspan: 1 }
  }
}

// 获取查询历史
const getHistoryList = async () => {
  loading.value = true
  try {
    const response = await postWlApi('/query_history', {})
    if (response.code === 0) {
      historyList.value = response.data.histories
      total.value = response.data.histories.length
      formatHistoryData()
    } else {
      ElMessage.error(response.message || '获取查询历史失败')
    }
  } catch (error) {
    console.error('获取查询历史失败:', error)
    ElMessage.error('网络错误，请稍后重试')
  } finally {
    loading.value = false
  }
}

// 分页大小变化
const handleSizeChange = (size) => {
  pageSize.value = size
  currentPage.value = 1
  getHistoryList()
}

// 当前页码变化
const handleCurrentChange = (page) => {
  currentPage.value = page
  getHistoryList()
}

// 组件挂载时获取查询历史
onMounted(() => {
  getHistoryList()
})
</script>

<style scoped>
.query-history-container {
  width: 100vw;
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 20px;
  box-sizing: border-box;
}

.query-history-content {
  width: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.history-header {
  margin-bottom: 20px;
}

.history-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.history-list-container {
  margin-bottom: 20px;
  overflow: auto;
  max-height: calc(100vh - 350px);
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>